import React, { useEffect, useState } from 'react'
import { GetAll_WithPrice_Category_Api } from '../../API/CategoryApi';
import { ACategoryComponent } from './ACategoryComponent';

export const PriceCategoryComponent = (
    {
        setLoading,
        showMessage,
        onClickItems,
    }) => {
    // ======================================================================
    const [categories, setCategories] = useState([]);
    // ======================================================================
    useEffect(() => {
        loadData();
    }, []);
    // ======================================================================
    const loadData = async () => {
        setLoading(true);
        try {
            const data = await GetAll_WithPrice_Category_Api();
            setLoading(false);
            if (data.messageStatus == "Successful") {
                setCategories(data.messageData.data);
            }
            else {
                showMessage(data.message, "error")
            }
        }
        catch (error) {
            setLoading(false);
            showMessage("خطا در ارتباط با سرور.", "error")
        }
    }
    // ======================================================================
    return (
        <>
            <div className='sectionTitle'>
                <h2 >
                    لیست دسته بندی ها
                </h2>
            </div>
            <div className='container'>
                <ul className='category-list'>
                    {
                        categories?.map((category) =>
                            <>
                                <li className='category-item' key={category.id}>
                                    <ACategoryComponent
                                        setLoading={setLoading}
                                        showMessage={showMessage}
                                        category={category}
                                        isShowAddSubCategory={false}
                                        isShowEdit={false}
                                        isShowDelete={false}
                                        isLoadObjectInstanceCategories={false}
                                        isLoadCategoryFromParam={false}
                                        isShowCheckBox={false}
                                        onClickItems={onClickItems}
                                    />
                                </li>
                            </>
                        )
                    }
                </ul>
            </div>
        </>
    )
}